import { useEffect, useState } from "react";
import { t } from "@/lib/i18n";
import { ChevronLeft, ChevronRight, ShoppingBag, Droplets, Recycle, Lightbulb, Bike, Sprout, Ban, Shirt } from "lucide-react";

const TIPS = [
  { icon: Recycle, title: "Keep two bins at home", body: "One for dry waste, one for wet. It's the single biggest help to your kabadiwala and city." },
  { icon: ShoppingBag, title: "Carry a cloth bag", body: "Keep one folded in your scooter or handbag — say no to single-use polythene." },
  { icon: Droplets, title: "Rinse before you recycle", body: "A quick rinse of bottles and containers keeps your dry waste clean and sellable." },
  { icon: Ban, title: "Never burn waste", body: "Burning plastic or leaves releases toxic smoke. Compost leaves, recycle the rest." },
  { icon: Lightbulb, title: "Switch off at the plug", body: "Chargers and TVs on standby still draw power. Switch off when not in use." },
  { icon: Bike, title: "Walk the short trips", body: "For errands under 1–2 km, walking or cycling is often just as quick." },
  { icon: Sprout, title: "Start a small compost pot", body: "Kitchen scraps + dry leaves in a pot = free manure for your plants in a few weeks." },
  { icon: Shirt, title: "Repair, reuse, donate", body: "Old clothes and utensils can find a second life before they become waste." },
];

export default function ActionTips() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % TIPS.length), 6000);
    return () => clearInterval(t);
  }, []);
  const T = TIPS[i];
  const Icon = T.icon;
  return (
    <div className="bg-[var(--ink)] text-white rounded-3xl p-7 sm:p-9 grain overflow-hidden" data-testid="action-tips">
      <div key={i} className="fade-up">
        <div className="w-14 h-14 rounded-2xl bg-[var(--marigold)] text-[var(--ink)] flex items-center justify-center"><Icon size={26} /></div>
        <div className="mt-5 text-xs tracking-[0.2em] uppercase text-[#BFD8B8]">Small action #{i + 1}</div>
        <h3 className="mt-2 text-2xl sm:text-3xl font-bold" data-testid="action-tip-title">{t(T.title)}</h3>
        <p className="mt-3 text-[#D9D3C3] leading-relaxed">{t(T.body)}</p>
      </div>
      <div className="mt-8 flex items-center justify-between">
        <div className="flex gap-1.5">
          {TIPS.map((_, k) => <span key={k} className={`h-1.5 rounded-full transition-all ${k === i ? "w-6 bg-[var(--marigold)]" : "w-1.5 bg-white/25"}`} />)}
        </div>
        <div className="flex gap-2">
          <button onClick={() => setI((n) => (n - 1 + TIPS.length) % TIPS.length)} className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10" aria-label="Previous tip" data-testid="action-tip-prev"><ChevronLeft size={18} /></button>
          <button onClick={() => setI((n) => (n + 1) % TIPS.length)} className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10" aria-label="Next tip" data-testid="action-tip-next"><ChevronRight size={18} /></button>
        </div>
      </div>
    </div>
  );
}
